import { FormGroup, FormControl } from '@angular/forms';
import { BaseComponent } from './base.component';

export class AdmissionReportsBase extends BaseComponent {

    constructor() {
        super();
    }
}
